import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

import SettingsWrapper from '../SettingsWrapper.vue';
import TicketSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tickets/:section?'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_jov_tickets',
          component: TicketSettings,
          meta: {
            featureFlag: FEATURE_FLAGS.JOV_TICKETS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
